module.exports = __webpack_public_path__ + "img/c7.3584e2fa.jpg";